module.exports = __webpack_public_path__ + "static/moto-62d42fc74e3f274ec921c8f9c92c0c49.png";